import { CheckCircleOutlined, EditOutlined, StopOutlined, RedoOutlined, DollarCircleOutlined, FileDoneOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, dineroDisabledMask, SegmentedItem } from "../../../Components/Items";
import AgregarCajaEfectivo from "./AgregarCajaEfectivo/AgregarCajaEfectivo";
import EditarCajaEfectivo from "./EditarCajaEfectivo/EditarCajaEfectivo";
import { filtrarPorIds, idsPermitidosSeleccion } from "../../../Utils/permisos.utils";

class CajaEfectivo extends Component {
  state = {
    todasCajaEfectivo: [],
    modalAgregarCajaEfectivo: false,
    modalEditarCajaEfectivo: false,
    modalEditarCajaEfectivoId: null,
    loading: false,
    valor: 1,
  };
  componentDidMount() {
    this.consultarCajaEfectivo(this.state.valor);
  }

  consultarCajaEfectivo(valor) {
    this.setState({ loading: true })
    axios
      .post(
        "cajaefectivo/selectTodosCajaEfectivo",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.status === 404) {
          this.setState({ todasCajaEfectivo: [] });
        } else {
          // Excluir las cajas chicas que el usuario no tiene permitidas.
          const cajasPermitidas = filtrarPorIds(
            res.data,
            this.props.permisoCajasPermitidas
          );
          this.setState({
            todasCajaEfectivo: cajasPermitidas.map(value => {
              return { ...value, accion: { _id: value._id, estado: value.estado, nombre: value.nombre } }
            }),
          });
        }
      });
  }

  abrirAgregarCajaEfectivo() {
    this.setState({ modalAgregarCajaEfectivo: true });
  }
  cerrarAgregarCajaEfectivo() {
    this.setState({ modalAgregarCajaEfectivo: false });
    this.consultarCajaEfectivo(this.state.valor);
  }
  abrirEditarCajaEfectivo(id) {
    this.setState({ modalEditarCajaEfectivo: true, modalEditarCajaEfectivoId: id });
  }
  cerrarEditarCajaEfectivo() {
    this.setState({ modalEditarCajaEfectivo: false });
    this.consultarCajaEfectivo(this.state.valor);
  }
  deshabilitarCajaEfectivo(value) {
    axios
      .post(
        "cajaefectivo/deshabilitarCaja",
        { cajaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Caja efectivo deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarCajaEfectivo(this.state.valor);
      });
  }
  habilitarCajaEfectivo(value) {
    axios
      .post(
        "cajaefectivo/habilitarCaja",
        { cajaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Caja efectivo habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarCajaEfectivo(this.state.valor);
      });
  }
  abrirReponerCajaChica(id, nombre) {
    this.props.history.push('/panel/reponerCajaChica', { id, nombre })
  }
  abrirSaldarCajaChica(id, nombre) {
    this.props.history.push('/panel/reponerCajaChica', { id, nombre, modoSaldar: true })
  }
  abrirPagarCxpCajaChica(id, nombre) {
    this.props.history.push('/panel/pagarCxpCajaChica', { id, nombre })
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Banco",
        dataIndex: "banco",
        key: "banco",
        responsive: ["md"],
        sorter: (a, b) => {
          if (a.banco < b.banco) {
            return -1;
          }
          if (a.banco > b.banco) {
            return 1;
          }
          return 0;
        },
        buscar: "banco",
      },
      {
        title: "Cuenta Contable",
        dataIndex: "cuentacontable",
        key: "cuentacontable",
        responsive: ["md"],
        render: (value) => value.descripcion
      },
      {
        title: "Moneda",
        dataIndex: "moneda",
        key: "moneda",
        responsive: ["md"],
        render: (value) => (value.abreviacion + " - " + value.nombre)
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        render: (value) => dineroDisabledMask(value)
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "18%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          let buttons = [];

          if (this.props.permisoEditarCajasChicas) {
            buttons.push(
              <Tooltip title="Editar Caja" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarCajaEfectivo(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarCajaChica) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar esta caja"
                  onConfirm={() => this.deshabilitarCajaEfectivo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar esta caja"
                  onConfirm={() => this.habilitarCajaEfectivo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }
          if (this.props.permisoReponerCajaChica) {
            buttons.push(
              <Tooltip title="Reponer" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`reponer-${index}`}
                  type='primary'
                  size='small'
                  azul
                  icon={<RedoOutlined />}
                  onClick={() => this.abrirReponerCajaChica(value._id, value.nombre)}
                >

                </ButtonItem>
              </Tooltip>
            );
            buttons.push(
              <Tooltip title="Saldar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`saldar-${index}`}
                  type='primary'
                  size='small'
                  olivo
                  icon={<DollarCircleOutlined />}
                  onClick={() => this.abrirSaldarCajaChica(value._id, value.nombre)}
                >
                </ButtonItem>
              </Tooltip>
            );
            buttons.push(
              <Tooltip title="Pagar facturas de CxP" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`pagarCxp-${index}`}
                  type='primary'
                  size='small'
                  morado
                  icon={<FileDoneOutlined />}
                  onClick={() => this.abrirPagarCxpCajaChica(value._id, value.nombre)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Caja y Efectivo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={

            <>
            {window.innerWidth > 1000 &&
              <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarCajaEfectivo(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
          }
              {this.props.permisoAgregarCajasChicas && (
                <ButtonItem
                  type="primary"
                  key="agregarCajaEfectivo"
                  olivo
                  onClick={this.abrirAgregarCajaEfectivo.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Caja
                </ButtonItem>
              )}

            </>
          }
        />
        <TableItem
          size='small'
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verPagosCajaChica", { cajaChicaId: record._id });
              },
            };
          }}
          loading={this.state.loading}
          dataSource={this.state.todasCajaEfectivo}
          columns={columns}
        />
        {this.props.permisoAgregarCajasChicas &&
          <AgregarCajaEfectivo
            visible={this.state.modalAgregarCajaEfectivo}
            cerrarAgregarCajaEfectivo={this.cerrarAgregarCajaEfectivo.bind(
              this
            )}
          />
        }
        {this.props.permisoEditarCajasChicas &&
          <EditarCajaEfectivo
            id={this.state.modalEditarCajaEfectivoId}
            visible={this.state.modalEditarCajaEfectivo}
            cerrarEditarCajaEfectivo={this.cerrarEditarCajaEfectivo.bind(
              this
            )}
          />
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisos: state.user.permisos,
    tipo: state.user.tipo,
    permisoAgregarCajasChicas: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca6f5f30e81b54183cf50")?.activado,
    permisoEditarCajasChicas: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca733f30e81b54183cf51")?.activado,
    permisoReponerCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cb9e4f30e81b54183cf53")?.activado,
    permisoDeshabilitarCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cb951f30e81b54183cf52")?.activado,
    permisoCajasPermitidas: idsPermitidosSeleccion(state.user.permisos, state.user.tipo, "615ca6b1f30e81b54183cf4f"),
  };
};

export default connect(mapStateToProps)(CajaEfectivo);
